import { LostRecyclingRateGraph } from "./components/graph";
import { RecoverableRateCard } from "./components/recoverableRateCard";

export const LostRecyclingRate = () => {
  return (
    <div className="border-grey2 rounded-xl border bg-white p-[22px]">
      <div className="flex flex-wrap items-center gap-[28px]">
        <LostRecyclingRateGraph />

        <RecoverableRateCard />
      </div>
    </div>
  );
};
